// src/pages/personal/analytics/CustomerSection/components/LtvChart.tsx
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart } from '@/components/ui/Charts';
import { COLORS } from '@/theme';
// Импортируем форматтеры
import { formatNumber } from '@/utils/Formatters';
// Импортируем процессор данных для графиков

interface ChartData {
  name: string;
  value: number;
  clients: number;
  color: string;
  status: string;
}

interface LtvChartProps {
  data: ChartData[];
}

const LtvChart: React.FC<LtvChartProps> = ({ data }) => {
  const { t, i18n } = useTranslation('customer');
  const currentLocale = i18n.language;
  
  // Обрабатываем данные с использованием общего процессора
  const processedData = useMemo(() => {
    // Данные уже отсортированы по статусам клиентов,
    // но мы можем дополнительно обработать их для корректного отображения
    return data.map(item => ({
      ...item,
      displayName: item.name
    }));
  }, [data]);
  
  // Определяем серии данных с разными yAxisId для левой и правой оси
  const series = [
    {
      name: t('ltv_analysis.frequency'),
      dataKey: 'value',
      color: COLORS.primary,
      yAxisId: 'left',
    },
    {
      name: t('ltv_analysis.clients_count'),
      dataKey: 'clients',
      color: '#82ca9d',
      yAxisId: 'right',
    }
  ];
  
  // Настройки для тултипа с форматированными данными
  const tooltipFormatter = (value: number, name: string) => {
    if (name === t('ltv_analysis.frequency')) {
      return formatNumber(value, 2, true, currentLocale);
    }
    return formatNumber(value, 0, true, currentLocale);
  };
  
  return (
    <BarChart
      data={processedData}
      series={series}
      xAxisKey="name"
      yAxisLabel={t('ltv_analysis.frequency')}
      showGrid={true}
      showLegend={true}
      barSize={40}
      borderRadius={4}
      tooltipFormatter={tooltipFormatter}
      size="md"
    />
  );
};

export default LtvChart;